import { Component, OnInit, ViewChild } from '@angular/core';
import { NotificationService } from '@app/feature/main/roles-shared/services/notification.service';
import swal from "sweetalert2";
import { Router } from '@angular/router';
import { AuthenticationService } from '@app/shared/services/authentication.service';
import { ConnectMiniProfileComponent } from "@app/shared/components/connect-mini-profile/connect-mini-profile.component";

@Component({
  selector: 'app-push-notifications',
  templateUrl: './push-notifications.component.html',
  styleUrls: ['./push-notifications.component.css']
})
export class PushNotificationsComponent implements OnInit {
@ViewChild(ConnectMiniProfileComponent) connectionMini: ConnectMiniProfileComponent;
notificationList:any=[];
userRole;
messageCount : number;
userId;
value = 1;
  constructor(private notificationService:NotificationService ,
    private router: Router,
    private authenticationService: AuthenticationService,
  ) { }

  ngOnInit() {
    this.getRole();
    this.getUserId();
    this.getNotificationsList();
    this.getUnreadMessageCount();
  }
  getNotificationsList(){
    this.notificationService.getAllNotification().subscribe(
      (data:any)=>{
      this.notificationList=data['data'];
      },
      error=>{
        swal("Info", error.error.error.message, "info");
      }
    );
  }

  getRole() {
    this.userRole = this.authenticationService.getFormattedRole();
  }
  getUserId(){
    this.userId = this.authenticationService.getUserId();
  }
  goToDetailsPage(notificationObj) {
    if (notificationObj && notificationObj.payload) {
      if ((notificationObj.readStatus === false)) {
        this.updateUnreadMessage(notificationObj.id);
      }
      if (notificationObj.payload.userActivityType == 'project') {
        if(notificationObj.payload.postType === 'project_document_uploaded'){
        }
        switch (notificationObj.payload.postType) {
          case 'project_document_uploaded':{
            this.router.navigate([`${this.userRole}/projects/progressing-projects/${notificationObj.payload.userActivityId}/documents`]);
          break;
          }
          case 'project_document_deleted':{
            this.router.navigate([`${this.userRole}/projects/progressing-projects/${notificationObj.payload.userActivityId}/documents`]);
            break;
          }
        }
        switch (notificationObj.payload.projectStatus) {
          case "bid": {            
            if (notificationObj.payload.postType === 'project_bid_request_accept') {
              this.router.navigate([`${this.userRole}/projects/acceptedProjects`]);
            } else{
              this.router.navigate([`${this.userRole}/projects/pendingProjects`]);
            }
            break;
          }
          case "open": {
            if (notificationObj.payload.postType === 'project_bid_request_accept') {
              this.router.navigate([`${this.userRole}/projects/acceptedProjects`]);
            } else{
              this.router.navigate([`${this.userRole}/projects/openProjects`]);
            }            
            break;
          }
          case "accepted": {
            this.router.navigate([`${this.userRole}/projects/acceptedProjects`]);
            break;
          }
          case "inprogress": {
            this.router.navigate([`${this.userRole}/projects/inProgressProjects`]);
            break;
          }
          case "completed": {
            this.router.navigate([`${this.userRole}/projects/completedProjects`]);
            break;
          }
          case "cancelled": {
            this.router.navigate([`${this.userRole}/projects/cancelled`]);
            break;
          }
          case "declined": {
            this.router.navigate([`${this.userRole}/projects/declined`]);
            break;
          }
        }
        
      }
      switch (notificationObj.payload.postType) {
        case "analyst": {
          this.router.navigate(['../../analyst-profile'] , { queryParams: { analystId: notificationObj.payload.postId } });
          break;
       }
        case "research_document": {
          if (this.userRole === 'tech-vendor') {
            this.router.navigate([`${this.userRole}/market-data/${notificationObj.payload.postId}`]);
          } else {
            this.router.navigate([`${this.userRole}/research-snapshot/${notificationObj.payload.postId}`]);
          }
          break;
        }
        case "admin_social_announcement": {
          this.router.navigate([`${this.userRole}/social-feeds`]);
          break;
        }
        case "report": {
          if (this.userRole === "tech-analyst" && notificationObj.payload.status === 'review_failed') {
            this.router.navigate([`${this.userRole}/reports`]);
            this.updateUnreadMessage(notificationObj.id)

          } else if (this.userRole === "tech-analyst") {
            this.router.navigate([`${this.userRole}/reports/report-details/${notificationObj.payload.postId}`]);
          } else {
            this.router.navigate([`${this.userRole}/report-details/${notificationObj.payload.postId}`]);
          }
          break;
        }
        case "token": {
          this.router.navigate([`${this.userRole}/my-profile`]);
          break;
        }
        case "like": {
          if (notificationObj.payload.itemType) {
            if (notificationObj.payload.itemType === "report") {
              if (this.userRole === "tech-analyst") {
                this.router.navigate([`${this.userRole}/reports/report-details/${notificationObj.payload.postId}`]);
              } else {
                this.router.navigate([`${this.userRole}/report-details/${notificationObj.payload.postId}`]);
              }
            } else if (notificationObj.payload.itemType === "research_document") {
              if (this.userRole === 'tech-vendor') {
                this.router.navigate([`${this.userRole}/market-data/${notificationObj.payload.postId}`]);
              } else {
                this.router.navigate([`${this.userRole}/research-snapshot/${notificationObj.payload.postId}`]);
              }
            }
          }
          break;
        }
        case "subscription": {
          this.router.navigate([`${this.userRole}/subscriptions`]);
          break;
        }
        case "follow": {
          if (notificationObj.payload.roleCode) {
            if (notificationObj.payload.roleCode === "tech_analyst") {
              this.router.navigate(['../../analyst-profile'], { queryParams: { analystId: notificationObj.payload.userId } });
            } else {
              if (notificationObj.payload.userId) {
                this.connectionMini.getProfileData(notificationObj.payload.userId);
              }
            }
          }
          break;
        }
        case "highlights": {
          if (this.userRole === "tech-analyst") {
            this.router.navigate([`${this.userRole}/dashboard`]);
          }
          break;
        }
        case "invite": {
          if (this.userRole === "tech-vendor") {
            this.router.navigate([`${this.userRole}/subscriptions/company`]);
          }
          break;
        }
        case "comment": {
          if (notificationObj.payload.itemType) {
            if (notificationObj.payload.itemType === "report") {
              if (this.userRole === "tech-analyst") {
                this.router.navigate([`${this.userRole}/reports/report-details/${notificationObj.payload.postId}`]);
              } else {
                this.router.navigate([`${this.userRole}/report-details/${notificationObj.payload.postId}`]);
              }
            } else if (notificationObj.payload.itemType === "research_document") {
              if (this.userRole === 'tech-vendor') {
                this.router.navigate([`${this.userRole}/market-data/${notificationObj.payload.postId}`]);
              } else {
                this.router.navigate([`${this.userRole}/research-snapshot/${notificationObj.payload.postId}`]);
              }
            } else if (notificationObj.payload.itemType === "market_data") {
              if (this.userRole === 'tech-vendor') {
                this.router.navigate([`${this.userRole}/market-data/${notificationObj.payload.researchDocumentId}`]);
              } else {
                this.router.navigate([`${this.userRole}/research-snapshot/${notificationObj.payload.researchDocumentId}`]);
              }
            } else {
              this.router.navigate([`${this.userRole}/social-feeds`]);
            }
          }
          break;
        }
        case "connection": {
          this.router.navigate([`${this.userRole}/my-connections`]);
        }
        default: {
          break;
        }
      }

    }
  }
  getUnreadMessageCount(){
    this.notificationService.getUnreadMessageCount().subscribe((response)=>{
      this.messageCount = response['unreadCount'];
    })
  }
  goToMessages(){
    this.router.navigate([`${this.userRole}/messages`]);
  }
  updateUnreadMessage(logId){
    this.notificationService.readNotificationUpdation(logId).subscribe((response)=>{
    this.sendMessage(this.value);
    })
  }
  sendMessage(value): void {
    this.notificationService.sendMessage(value.toString());
}
}



// WEBPACK FOOTER //
// ./src/app/feature/main/roles-shared/components/push-notifications/push-notifications.component.ts